// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"6dea6bc9db436f09ee0f","293":"1aca5d2a617feec85aeb","522":"d65956d508c2d99ee9e9"}[chunkId] + ".js";
};